const trips = {
  statuses: {
    new: 'Awaiting Fleet',
    approved: 'Accepted',
    canceled: 'Declined',
  },
  table: {
    floatingActions: {
      tooltips: {
        accept: 'This action is only available for trips with  ‘Awaiting Fleet’ status.',
        decline: 'This action is only available for trips with  ‘Awaiting Fleet’ status.',
      },
    },
    filters: {
      supplier: 'Fleets',
    },
    statuses: {
      new: 'Awaiting Fleet',
      approved: 'Accepted',
      canceled: 'Declined',
    },
    headers: {
      supplier: 'Fleet',
    },
    cells: {
      supplier: {
        none: 'No Fleet',
      },
      actions: {
        approve: 'Accept',
        remove: 'Decline',
      },
    },
  },
};

export default trips;
